// extracted by mini-css-extract-plugin
export default {"menuIconButton":"workflow-menu-module__menuIconButton--duQKW","actionMenuOverlay":"workflow-menu-module__actionMenuOverlay--r5gel"};